<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.ORDER_LIST.ORDER_NUM' | translate }}
				</td>

				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.ORDER_LIST.PAYMENT' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.ORDER_LIST.CLIENT_INFO' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.ORDER_LIST.PRODUCT_NUM' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.ORDER_LIST.CITY_AREA' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.ORDER_LIST.DATE' | translate }}
				</td>

				<td></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let order of ordersList
						| paginate
							: {
									itemsPerPage: orderFilter?.paging?.pageSize,
									currentPage: orderFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
				class="{{
					indx + 1 != ordersList?.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					[routerLink]="['order-details', order.id]"
					class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[240px]"
				>
					<span
						class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
					>
						<h1
							class="text-font-16 text-dark-grey max-mobile:text-font-12 mb-0"
						>
							#{{ order?.orderNumber }}
						</h1>
					</span>
				</td>

				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-grey-background py-[14px] px-[15px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p class="m-0">
						<span>
							{{ order?.totalPayment }}

							{{
								translate.currentLang == 'en'
									? order?.currency?.en
									: order?.currency?.ar
							}}
						</span>
					</p>
					<p>
						{{
							translate.currentLang == 'en'
								? order?.paymentMethod?.nameEn
								: order?.paymentMethod?.nameAr
						}}

						|
						<span
							[ngClass]="
								order?.paymentStatus == 2 ? 'text-[#B3261E]' : 'text-[#00BA88]'
							"
						>
							{{
								order?.paymentStatus == 2
									? ('STATUS.UNPAID' | translate)
									: ('STATUS.PAID' | translate)
							}}
						</span>
					</p>
				</td>

				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ order?.clientName }}
					<p *ngIf="order?.phone" class="text-font-14 text-medium-gray">
						{{ order?.phone }}
						<img
							*ngIf="order?.isClientPhoneVerified"
							[src]="'assets/images/verified.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
						<img
							*ngIf="!order?.isClientPhoneVerified"
							[src]="'assets/images/not-verified.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</p>
				</td>

				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[170px]"
				>
					{{ order?.productNumber }}
					{{ 'STORE.ORDER_LIST.PRODUCTS' | translate }}
					<p class="text-font-14 text-medium-gray">
						{{ order?.quantity }} {{ 'STORE.ORDER_LIST.ITEM' | translate }}
					</p>
				</td>

				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{
						translate.currentLang == 'en' ? order?.city?.en : order?.city?.ar
					}}

					<p class="text-font-14 text-medium-gray">
						{{
							translate.currentLang == 'en' ? order?.area?.en : order?.area?.ar
						}}
					</p>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ order?.creationDate | date : 'dd/MM/yyyy' : 'UTC' }}
					<p class="text-font-14 text-medium-gray">
						{{ order?.creationDate | date : 'hh:mm a' : 'UTC' }}
					</p>
				</td>

				<td
					class="text-font-16 text-right leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span
						*ngIf="orderFilter?.orderStatus !== 1 && order.status !== 1"
						class="inline-block max-mobile:w-[20px] w-[16px] mx-2 text-end"
						(click)="openStatus(order)"
					>
						<img
							[src]="'assets/images/details.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</span>
					<span
						[routerLink]="['order-details', order.id]"
						class="inline-block max-mobile:w-[20px] w-[16px] text-end mt-1"
					>
						<img
							[src]="'assets/images/view.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>
